import Form, { FormProps, Rule } from "@/shared/form/form";
import Input from "@/shared/form/input";
import InputNumber from "@/shared/form/input-number";
import { LocalizedValue } from "@/shared/form/localized-value";
import { DynamicAttributeTypeSelect } from "../../../entities/attribute/ui/attribute-form-view/dynamic-attribute-type-select";
import { EntitySelectView } from "@/modules/dynamic-attributes/feature/dynamic-attribute-entity-select";
import { SubmitButton, SubmitWrapper } from "@/shared/form/button";
import { useTranslations } from "use-intl";
import { FieldsType } from "../model/types";
import { ChangingAttributeCodeHint, ChangingAttributeTypeHint } from "./hints";

type AttributeFormViewProps = FormProps & {
  attributeCodeInUseValidator: Rule;
};

export function AttributeFormView({
  attributeCodeInUseValidator,
  ...formProps
}: AttributeFormViewProps) {
  const t = useTranslations("AttributeFormView");

  return (
    <Form layout="vertical" {...formProps}>
      <Form.Item<FieldsType> name="id" hidden>
        <Input />
      </Form.Item>

      <LocalizedValue
        label={t("Name")}
        name="name"
        render={({ placeholder }) => <Input placeholder={placeholder} />}
        myLocaleRules={[{ required: true }]}
      />

      <LocalizedValue
        label={t("Description")}
        name="description"
        render={({ placeholder }) => <Input placeholder={placeholder} />}
      />

      <Form.Item<FieldsType>
        name="attributeCode"
        label={t("Attribute code")}
        rules={[{ required: true }, attributeCodeInUseValidator]}
        extra={<ChangingAttributeCodeHint />}
      >
        <Input placeholder={t("Input attribute code")} />
      </Form.Item>

      <Form.Item<FieldsType> name="order" label={t("Order")}>
        <InputNumber placeholder={t("Input order")} className="!w-full" />
      </Form.Item>

      <Form.Item<FieldsType> name="group" label={t("Group")} hidden>
        <Input disabled placeholder={t("Enter group")} />
      </Form.Item>

      <Form.Item<FieldsType>
        name="type"
        label={t("Type")}
        rules={[{ required: true }]}
        extra={<ChangingAttributeTypeHint />}
      >
        <DynamicAttributeTypeSelect />
      </Form.Item>

      <Form.Item<FieldsType>
        name="dynamicAttributeEntity"
        label={t("Dynamic attribute entity")}
        rules={[{ required: true }]}
        hidden
      >
        <EntitySelectView disabled />
      </Form.Item>

      <Form.Item<FieldsType> name="category" hidden>
        <Input />
      </Form.Item>

      <SubmitWrapper>
        <SubmitButton />
      </SubmitWrapper>
    </Form>
  );
}
